module.exports = __webpack_public_path__ + "img/Awareness.b0d20f99.png";